<template>
  <v-card flat>
    <v-tabs>
      <v-tab @click="selectTab('org')">
        인사
      </v-tab>
      <v-tab @click="selectTab('etcorg')">
        비인사
      </v-tab>
    </v-tabs>
    <v-row>
      <v-col cols="12" md="4">
        <v-row>
          <v-col>
            <v-select :label="$t('company')" :items="companiesList" :item-value="item => item" item-text="asgn_shrt_nm" :disabled="switchFlag"
                      @change="companies_onChanged()" v-model="registOrg.retrieveData" hide-details dense outlined>
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <!-- 인사, 비인사 조직 트리 그리드 -->
            <div v-show="isSelectedTab('org')">
              <realgrid-tree
                ref="treeMenuGrid"
                :options="registOrg.treeOption"
                :fields="registOrg.treeFields"
                :columns="registOrg.treeColumns"
                :retrieveData="registOrg.retrieveData"
                :retrieveApi="retreiveregistOrg"
                :height="470"
              ></realgrid-tree>
            </div>
            <div v-show="isSelectedTab('etcorg')">
              <realgrid-tree
                ref="treeEtcOrgGrid"
                :options="etcOrg.treeOption"
                :fields="etcOrg.treeFields"
                :columns="etcOrg.treeColumns"
                :retrieveData="etcOrg.retrieveData"
                :retrieveApi="retrieveEtcOrg"
                :height="470"
              ></realgrid-tree>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4">
        <v-row>
          <v-col cols="4">
            <v-select :items="chooseOptions" item-value="key" item-text="title" v-model="retrieveData.option" :disabled="switchFlag" hide-details dense outlined>
            </v-select>
          </v-col>
          <v-col cols="4">
            <v-text-field hide-details dense outlined v-model="retrieveData.inputValue" @keyup.enter="getUser" :disabled="switchFlag"></v-text-field>
          </v-col>
          <v-col cols="4" align-self="center">
            <v-btn :disabled="switchFlag" @click="getUser" small color="primary">
              <v-icon>
                mdi-magnify
              </v-icon>
              {{ $t('label.retrieve') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <!-- 멤버 그리드 -->
            <v-skeleton-loader
              height="470px"
              type="table-thead, table-tbody"
              :loading="memberGridloading"
              v-if="memberGridloading"
              elevation="2"
            ></v-skeleton-loader>
            <div ref="MemberListRealGrid" class="realgrid_style" v-show="!memberGridloading"></div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4" class="align-self-end">
        <v-row>
          <v-col cols="2" align-self="center">
            <v-btn @click="addMemberToselectedList" small class="primary"><v-icon>mdi-chevron-double-right</v-icon></v-btn>
          </v-col>
          <v-col cols="10">
            <!-- 추가 그리드 -->
            <v-skeleton-loader
              height="470px"
              type="table-thead, table-tbody"
              :loading="selectedGridloading"
              v-if="selectedGridloading"
              elevation="2"
            ></v-skeleton-loader>
            <div ref="selectedListRealGrid" class="realgrid_style" v-show="!selectedGridloading"></div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Message from '@/utils/message'
import {
  getAllOrganizationTreeList,
  getCompanies,
  getUserList
} from '@/api/common/organizations' // 조직 및 인원 정보 조회
import { getScrollOption } from '@/utils/scroll'
import { getCompanys, getEtcOrg } from '@/api/manager/menu'
import RealGridFactory from '@/utils/realgrid2'
import RealgridTree from '@/components/grid/RealgridTree'
import DispatchResize from '@/mixins/DispatchResize'

export default {
  name: 'Members',
  components: {
    RealgridTree
  },
  props: {
    value: {},
    selected: Function,
    multiCheck: {
      type: Boolean,
      default: false
    }
  },
  mixins: [DispatchResize()],
  data() {
    return {
      selectedGridloading: true,
      memberGridloading: true,
      checkDblFlag: true,
      tabOps: {},
      switchFlag: false,
      retrieveData: {
        option: '',
        company: '',
        job_tit_nm: '',
        kor_nm: '',
        asgn_cd: '',
        asgn_shrt_nm: '',
        inputValue: ''
      },
      ops: {
        vuescroll: {
          mode: 'native',
          sizeStrategy: 'percent',
          detectResize: true // DOM 크기 감지 여부
        },
        rail: {
          size: '10px', // 가로크기, default : 6px
          gutterOfEnds: '5px', // X축, Y축 양 끝에서의 거리, default : 2px
          gutterOfSide: '0' // 컨테이너 측면으로부터 거리, default : 2px
        },
        bar: {
          keepShow: true, // 계속 보여줄지 여부, default : false
          background: '#656a76', // @subColor_05
          opacity: 0.2,
          hoverStyle: false,
          size: '5px' // default : 6px
        },
        // 스크롤 좌우 버튼
        scrollButton: {
          enable: false // 사용 가능 여부
        },
        scrollPanel: {
          scrollingY: false // 스크롤 할 것인지 여부, default : true
        }
      },
      flags: {
        inited: false,
        default: false,
        verDefault: false,
        mapDefault: false
      },
      tabInfo: {
        selectedTab: 'org',
        active: [
          'bg-white',
          'block',
          'border-l',
          'border-t',
          'border-r',
          'rounded-t',
          'py-2',
          'px-4',
          'text-blue-dark',
          'font-semibold',
          'box_border_color',
          'text-blue-600'
        ],
        deactive: [
          'bg-white',
          'block',
          'py-2',
          'px-4',
          'text-blue',
          'hover:text-blue-darker',
          'font-semibold',
          'text-blue-600'
        ]
      },
      visible: false,
      selDeptName: '',
      companiesList: [],
      chooseOptions: [
        {
          key: 'D',
          title: '부서'
        },
        {
          key: 'E',
          title: '사용자'
        }
      ],
      selectedNode: {
        tree: '',
        children: '',
        asgn_shrt_nm: '',
        asgn_cd: '',
        prnt_cd: '',
        level: '',
        clss_cd: '',
        asgn_full_nm: '',
        company: '',
        checkAble: ''
      },
      registOrg: {
        // 메뉴 트리 그리드
        modal: false,
        usermodal: false,
        gridObj: '', // 그리드 인스턴스
        gridData: '', // 그리드 데이터
        retrieveData: {
          company: '',
          asgn_cd: ''
        },
        treeOption: {
          tree: {
            idCol: 'asgn_cd', // 트리 구조를 만들 때 사용 할 아이디 컬럼
            prntIdCol: 'prnt_cd', // 트리 구조를 만들 때 사용 할 부모 아이디 컬럼
            levelCol: 'level', // 트리 구조를 만들 때 사용할 레벨 컬럼
            childCol: 'children', // 트리 구조를 만들 때 자식 노드들이 들어갈 컬럼
            sortCol: 'CLSS_CD' // 트리 구조를 만들 때 정렬을 위한 컬럼
          },
          // treeView 영역에 셋팅할 옵션들
          treeView: {
            edit: {
              appendable: true,
              insertable: true,
              deletable: true
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정 하지 않음
              fitStyle: 'even'
            },
            stateBar: {
              visible: false
            },
            footers: {
              visible: false
            },
            checkBar: {
              visible: false
            }
          },
          // dataProvider 영역에 셋팅할 옵션들
          treeDataProvider: {
            softDeleting: true,
            deleteCreated: true
          }
        }
      },
      etcOrg: {
        retrieveData: {
          company: '',
          asgn_cd: ''
        },
        // 그리드 옵션값
        treeOption: {
          tree: {
            idCol: 'asgn_cd', // 트리 구조를 만들 때 사용 할 아이디 컬럼
            prntIdCol: 'prnt_cd', // 트리 구조를 만들 때 사용 할 부모 아이디 컬럼
            levelCol: 'level', // 트리 구조를 만들 때 사용할 레벨 컬럼
            childCol: 'children', // 트리 구조를 만들 때 자식 노드들이 들어갈 컬럼
            sortCol: 'seq' // 트리 구조를 만들 때 정렬을 위한 컬럼
          },
          // treeView 영역에 셋팅할 옵션들
          treeView: {
            edit: {
              appendable: true,
              insertable: true,
              deletable: true
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정 하지 않음
              fitStyle: 'even'
            },
            stateBar: {
              visible: false
            },
            footers: {
              visible: false
            },
            checkBar: {
              visible: false
            }
          },
          // dataProvider 영역에 셋팅할 옵션들
          treeDataProvider: {
            softDeleting: true,
            deleteCreated: true
          }
        },
        // 그리드 filed 배열
        treeFields: [],
        // 그리드 컬럼 배열
        treeColumns: []
      },
      MemberListGrid: {
        gridObj: '', // 그리드 인스턴스
        gridData: '',
        // retrieveData: {
        //   // 조회 파라미터
        //   company: '',
        //   dept_cd: '',
        //   user_nm: ''
        // },
        // 그리드 옵션값
        gridOption: {
          gridView: {
            edit: {
              appendable: true,
              insertable: true,
              deletable: true
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            },
            stateBar: {
              // 상태바 숨김
              visible: false
            },
            footers: {
              visible: false
            }
          },
          dataProvider: {
            softDeleting: true,
            deleteCreated: true
          }
        },
        // 그리드 filed 배열
        gridFields: [],
        // 그리드 컬럼 배열
        gridColumns: []
      },
      selectedListGrid: {
        gridObj: '', // 그리드 인스턴스
        gridData: '',
        // 그리드 옵션값
        gridOption: {
          gridView: {
            edit: {
              appendable: true,
              insertable: true,
              deletable: true
            },
            panel: {
              // 상단 패널 숨김
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            },
            stateBar: {
              // 상태바 숨김
              visible: false
            },
            footers: {
              visible: false
            }
          },
          dataProvider: {
            softDeleting: true,
            deleteCreated: true
          }
        },
        // 그리드 filed 배열
        gridFields: [],
        // 그리드 컬럼 배열
        gridColumns: []
      }
    }
  },
  created() {
    this.registOrg.treeFields = [
      // menuTree 구조를 위한 필수 field들
      { fieldName: 'tree', dataType: 'text' },
      { fieldName: 'children', dataType: 'text' }, // treeOption.tree.childCol 과 동일해야한다
      // 조회 후 넘어오는 data 필드들
      { fieldName: 'asgn_shrt_nm', dataType: 'text' },
      { fieldName: 'asgn_cd', dataType: 'text' }, // teeOption.tree.idCol 과 동일
      { fieldName: 'prnt_cd', dataType: 'text' }, // teeOption.tree.prntCol 과 동일
      { fieldName: 'level', dataType: 'number' }, // teeOption.tree.levelCol 과 동일
      { fieldName: 'clss_cd', dataType: 'text' }, // teeOption.tree.sortCol 과 동일
      { fieldName: 'asgn_full_nm', dataType: 'text' }, // teeOption.tree.sortCol 과 동일
      { fieldName: 'company', dataType: 'text' }, // teeOption.tree.sortCol 과 동일
      { fieldName: 'checkAble', dataType: 'text' } // 체크 가능 여부
    ]

    // 트리 컬럼에는 사용자에게 보여질 컬럼만 선언되면 된다.
    this.registOrg.treeColumns = [
      {
        name: 'asgn_shrt_nm',
        fieldName: 'asgn_shrt_nm',
        header: {
          text: '이름'
        },
        width: 220,
        editable: false
      }
    ]

    this.etcOrg.treeFields = [
      { fieldName: 'asgn_cd', dataType: 'text' },
      { fieldName: 'asgn_shrt_nm', dataType: 'text' },
      { fieldName: 'children', dataType: 'text' },
      { fieldName: 'company', dataType: 'text' },
      { fieldName: 'bsns_cd', dataType: 'text' },
      { fieldName: 'prnt_cd', dataType: 'text' },
      { fieldName: 'insert_user_id', dataType: 'text' },
      { fieldName: 'insert_date', dataType: 'text' },
      { fieldName: 'update_user_id', dataType: 'text' },
      { fieldName: 'update_date', dataType: 'text' }
    ]
    // 그룹 그리드 컬럼
    this.etcOrg.treeColumns = [
      {
        name: 'asgn_cd',
        fieldName: 'asgn_cd',
        header: {
          text: '소속코드'
        },
        width: 110,
        visible: true,
        editable: false
      },
      {
        name: 'asgn_shrt_nm',
        fieldName: 'asgn_shrt_nm',
        header: {
          text: '소속 조직명'
        },
        width: 150,
        visible: true,
        editable: false
      }
    ]
  },
  async mounted() {
    var response = await getCompanies()
    this.companiesList = response
    this.registOrg.retrieveData = this.companiesList[0]
    this.retrieveData.option = 'E'
    this.retrieveData.company = this.companiesList[0].company
    await this.setSelectedListGrid()
    await this.setMemberListGrid()
    await this.setetcOrgGrid()
    this.setTreeMenu()
  },
  computed: {
    retreiveregistOrg() {
      return getAllOrganizationTreeList
    },
    retrieveEtcOrg() {
      return getEtcOrg
    }
  },
  methods: {
    setTreeMenu() {
      this.$refs.treeMenuGrid.retrieve()
      this.$refs.treeMenuGrid.getTreeView().onCurrentRowChanged = (
        cgrid,
        oldDataRow,
        newDataRow
      ) => {
        this.registOrgGrid_RowChanged(newDataRow)
      }
    },
    async setetcOrgGrid() {
      this.$refs.treeEtcOrgGrid.retrieve()
      // RowChangeEvent
      this.$refs.treeEtcOrgGrid.getTreeView().onCurrentRowChanged = (
        cgrid,
        index
      ) => {
        var dataRow = this.$refs.treeEtcOrgGrid.getTreeView().getCurrent()
        this.selectedNode = this.$refs.treeEtcOrgGrid
          .getTreeDataProvider()
          .getJsonRow(dataRow.dataRow)
        this.retrieveData.job_tit_nm = this.selectedNode.job_tit_nm
        if (!this.selectedNode.children) {
          this.$nextTick(() => {
            this.selDeptName = this.selectedNode.asgn_shrt_nm
            this.retrieveData.option = 'D'
            this.retrieveData.asgn_cd = this.selectedNode.asgn_cd
            this.retrieveData.company = this.selectedNode.company
            this.getEtcUser()
          })
        }
      }
    },
    async setMemberListGrid() {
      this.MemberListGrid.gridFields = [
        { fieldName: 'company', dataType: 'text' },
        { fieldName: 'dept_cd', dataType: 'text' },
        { fieldName: 'user_id', dataType: 'text' },
        { fieldName: 'user_nm', dataType: 'text' },
        { fieldName: 'asgn_shrt_nm', dataType: 'text' },
        { fieldName: 'job_tit_nm', dataType: 'text' },
        { fieldName: 'role', dataType: 'text' },
        { fieldName: 'telno', dataType: 'text' }
      ]
      // 그룹 그리드 컬럼
      this.MemberListGrid.gridColumns = [
        {
          name: 'user_id',
          fieldName: 'user_id',
          header: {
            text: '이름'
          },
          width: 80,
          styles: {
            textAlignment: 'center'
          },
          visible: false,
          editable: false
        },
        {
          name: 'user_nm',
          fieldName: 'user_nm',
          header: {
            text: '이름'
          },
          width: 80,
          visible: true,
          editable: false
        },
        {
          name: 'job_tit_nm',
          fieldName: 'job_tit_nm',
          header: {
            text: '직위'
          },
          width: 80,
          visible: true,
          editable: false
        },
        {
          name: 'asgn_shrt_nm',
          fieldName: 'asgn_shrt_nm',
          header: {
            text: '조직 이름'
          },
          width: 100,
          visible: true,
          editable: false
        },

        {
          name: 'role',
          fieldName: 'role',
          header: {
            text: '직책'
          },
          width: 80,
          visible: true,
          editable: false
        },
        {
          name: 'telno',
          fieldName: 'telno',
          header: {
            text: '전화번호'
          },
          width: 80,
          visible: false,
          editable: false
        }
      ]
      this.MemberListGrid.gridObj = await RealGridFactory(
        this.$refs.MemberListRealGrid,
        this.MemberListGrid.gridOption
      )
      // dynamic 스타일 지정 및 그리드 컬럼,필드 셋팅
      this.MemberListGrid.gridObj.autoSetDynamicStyle(
        this.MemberListGrid.gridColumns
      )
      this.MemberListGrid.gridObj.initGrid(
        this.MemberListGrid.gridFields,
        this.MemberListGrid.gridColumns
      )
      this.memberGridloading = false
      this.MemberListGrid.gridObj.getGridView().onDataCellDblClicked = (
        cgrid,
        index
      ) => {
        // var a = this.registOrg.treeView.getCurrent()
        // var b = this.registOrg.treeDataProvider.getJsonRow(a.dataRow)
        var AllData = this.selectedListGrid.gridObj.d().getJsonRows(-1)
        var dataRow = this.MemberListGrid.gridObj.getGridView().getCurrent() // dataRow 값 가져옴
        var rowData = this.MemberListGrid.gridObj
          .getDataProvider()
          .getJsonRow(dataRow.dataRow) // row의 데이터 가져옴
        for (var key in AllData) {
          // 입력된 데이터와 같으면 return false
          if (rowData.user_id === AllData[key].user_id) {
            Message.err(
              '사용자 : [' +
                rowData.user_nm +
                ']님은 이미 존재하는 목록입니다.'
            )
            this.checkDblFlag = false
          } else {
          }
        }
        if (this.checkDblFlag === true) {
          this.selectedListGrid.gridObj
            .d()
            .insertRow(0, [
              rowData.company,
              rowData.dept_cd,
              rowData.user_id,
              rowData.user_nm,
              rowData.asgn_shrt_nm,
              rowData.job_tit_nm
            ]) // 기본값 셋팅
        } else {
        }
        this.checkDblFlag = true
        this.selectedListGrid.gridObj.getGridView().checkAll(true)
      }
    },
    async setSelectedListGrid() {
      this.selectedListGrid.gridFields = [
        { fieldName: 'company', dataType: 'text' },
        { fieldName: 'dept_cd', dataType: 'text' },
        { fieldName: 'user_id', dataType: 'text' },
        { fieldName: 'user_nm', dataType: 'text' },
        { fieldName: 'asgn_shrt_nm', dataType: 'text' },
        { fieldName: 'job_tit_nm', dataType: 'text' }
      ]
      // 그룹 그리드 컬럼
      this.selectedListGrid.gridColumns = [
        {
          name: 'user_nm',
          fieldName: 'user_nm',
          header: {
            text: '이름'
          },
          width: 80,
          visible: true,
          editable: false
        },
        {
          name: 'asgn_shrt_nm',
          fieldName: 'asgn_shrt_nm',
          header: {
            text: '조직 이름'
          },
          width: 100,
          visible: true,
          editable: false
        },
        {
          name: 'job_tit_nm',
          fieldName: 'job_tit_nm',
          header: {
            text: '직위'
          },
          width: 80,
          visible: true,
          editable: false
        }
      ]
      this.selectedListGrid.gridObj = await RealGridFactory(
        this.$refs.selectedListRealGrid,
        this.selectedListGrid.gridOption
      )
      // dynamic 스타일 지정 및 그리드 컬럼,필드 셋팅
      this.selectedListGrid.gridObj.autoSetDynamicStyle(
        this.selectedListGrid.gridColumns
      )
      this.selectedListGrid.gridObj.initGrid(
        this.selectedListGrid.gridFields,
        this.selectedListGrid.gridColumns
      )

      this.selectedGridloading = false
    },
    registOrgGrid_RowChanged(newDataRow) {
      this.selectedNode = this.$refs.treeMenuGrid
        .getTreeDataProvider()
        .getJsonRow(newDataRow)

      if (!this.selectedNode.children) {
        this.$nextTick(() => {
          this.selDeptName = this.selectedNode.asgn_shrt_nm
          this.retrieveData.inputValue = ''
          this.retrieveData.asgn_shrt_nm = ''
          this.retrieveData.kor_nm = ''
          this.retrieveData.company = this.selectedNode.company
          this.retrieveData.asgn_cd = this.selectedNode.asgn_cd
          this.getUser()
        })
      }
    },
    companies_onChanged() {
      this.$nextTick(() => {
        this.$refs.treeMenuGrid.retrieve()
      })
    },
    addMemberToselectedList() {
      var AllData = this.selectedListGrid.gridObj.d().getJsonRows(-1)
      var checkItems = this.MemberListGrid.gridObj
        .getGridView()
        .getCheckedItems() // check된 row itemIndex 가져옴

      for (let i = checkItems.length - 1; i >= 0; i--) {
        // 체크된 순서대로 넣기 위해 거꾸로 넣어줌
        var dataRow = this.MemberListGrid.gridObj
          .getGridView()
          .getDataRow(checkItems[i]) // dataRow 값 가져옴
        var rowData = this.MemberListGrid.gridObj
          .getDataProvider()
          .getJsonRow(dataRow) // row의 데이터 가져옴

        for (var key in AllData) {
          // 입력된 데이터와 같으면 return false
          if (rowData.user_id === AllData[key].user_id) {
            Message.err(
              '사용자 : [' +
                rowData.user_nm +
                ']님은 이미 존재하는 목록입니다.'
            )
            this.checkDblFlag = false
          } else {
          }
        }
        if (this.checkDblFlag === true) {
          this.selectedListGrid.gridObj
            .d()
            .insertRow(0, [
              rowData.company,
              rowData.dept_cd,
              rowData.user_id,
              rowData.user_nm,
              rowData.asgn_shrt_nm,
              rowData.job_tit_nm
            ]) // 기본값 셋팅
        }
        this.checkDblFlag = true
        this.selectedListGrid.gridObj.getGridView().checkItem(0, true)
      }
    },
    getUser() {
      if (this.retrieveData.inputValue !== undefined && this.retrieveData.inputValue !== '') {
        this.retrieveData.asgn_cd = null
        if (this.retrieveData.option === 'D') {
          this.retrieveData.asgn_shrt_nm = this.retrieveData.inputValue
          this.retrieveData.kor_nm = null
        } else {
          this.retrieveData.asgn_shrt_nm = null
          this.retrieveData.kor_nm = this.retrieveData.inputValue
        }
      }
      getUserList(this.retrieveData).then(res => {
        this.MemberListGrid.gridObj.fillByJson(res)
      })
    },
    getEtcUser() {
      if (this.retrieveData.inputValue !== undefined && this.retrieveData.inputValue !== '') {
        this.retrieveData.asgn_cd = null
        if (this.retrieveData.option === 'D') {
          this.retrieveData.asgn_shrt_nm = this.retrieveData.inputValue
          this.retrieveData.kor_nm = null
        } else {
          this.retrieveData.asgn_shrt_nm = null
          this.retrieveData.kor_nm = this.retrieveData.inputValue
        }
      }
      // this.retrieveData.company = this.registOrg.retrieveData.company
      getUserList(this.retrieveData).then(res => {
        this.MemberListGrid.gridObj.fillByJson(res)
      })
    },
    scrollOps() {
      let ops = {
        scrollPanel: {
          scrollingY: false,
          scrollingX: true
        }
      }
      this.tabOps = getScrollOption(ops)
    },
    // 현재 선택된 tab이면 v-show가 true 가 되어 해당 탭이 보여진다.
    isSelectedTab(tabName) {
      return this.tabInfo.selectedTab === tabName
    },
    // tab li 태그의 class 를 가져온다
    getTabNameLiClass(tabName) {
      return this.isSelectedTab(tabName) ? '-mb-px' : ''
    },
    // tab a 태그의 class 를 가져온다
    getTabNameAClass(tabName) {
      return this.tabInfo.selectedTab === tabName
        ? this.tabInfo.active
        : this.tabInfo.deactive
    },
    // 탭 클릭 이벤트
    async selectTab(tabName) {
      if (this.flags.default) return // FIXME : 마지막에 풀어라
      // 선택된 값을 변수에 담는다
      this.tabInfo.selectedTab = tabName
      this.retrieveData.inputValue = ''
      this.retrieveData.asgn_shrt_nm = ''
      this.retrieveData.kor_nm = ''
      if (this.tabInfo.selectedTab === 'etcorg') {
        this.switchFlag = true
      } else {
        this.switchFlag = false
      }
      this.$nextTick(() => {
        // 내부 그리드의 width가 시점 문제로 조정 되지 않는 이슈는 글로벌 이벤트로 해결
        this.dispatchResize()
      })
    },
    getSelectedItem() {
      let gridView = this.selectedListGrid.gridObj.g()
      let dataProvider = this.selectedListGrid.gridObj.d()
      gridView.commit()

      let gridSelData = {
        ok: true,
        selectedMembers: []
      }
      let rows = gridView.getCheckedRows(true)
      if (rows.length < 1) {
        Message.warn('선택된 대상이 없습니다.')
        return
      }
      rows.forEach((row, idx) => {
        let target = dataProvider.getJsonRow(row)
        gridSelData.selectedMembers.push(target)
      })
      this.selected(gridSelData.selectedMembers)
    }
  },
  beforeDestroy() {
  }
}
</script>

<style scoped>
  .realgrid_style {
    height: 470px;
  }
  .btn_con_clr1 {
    min-width: 40px;
  }
</style>
